import { ScrollTrigger } from "gsap/ScrollTrigger";

const ActorsTiles = () => {
	const block = document.querySelectorAll(".actors-tiles");
	if (!block) {
		return;
	}
	const scrollTriggerRefresh = () => {
		setTimeout(() => {
			ScrollTrigger.refresh();
		}, 200);
	};

	block.forEach((el) => {
		const disableMore = el.classList.contains("actors-tiles_disable-more");
		const items = el.querySelectorAll(".actors-tiles__list-item");
		const footer = el.querySelector(".actors-tiles__footer");
		const moreControl = el.querySelector(".actors-tiles__footer .custom-link");
		const itemsCount = 6;
		let itemsToShow = itemsCount;

		if (moreControl) {
			moreControl.addEventListener("click", (e) => {
				if (!disableMore) {
					itemsToShow = itemsToShow + itemsCount;

					items.forEach((item, index) => {
						if (index < itemsToShow && !item.classList.contains("active")) {
							item.classList.add("active");
						}
					});

					if (itemsToShow >= items.length) {
						footer.classList.add("actors-tiles__footer_hide")
					}
				}

				scrollTriggerRefresh();
			});
		}
	});
};

export default ActorsTiles;
